import { forwardRef } from 'react';

import Button, { ButtonProps } from '@material-ui/core/Button';

import { useStyles } from './style';

interface ActionButtonProps extends ButtonProps {}

const ActionButton = forwardRef<HTMLButtonElement, ActionButtonProps>(
  (props, ref) => {
    const classes = useStyles();

    return (
      <Button
        {...props}
        ref={ref}
        classes={{
          root: classes.root,
          startIcon: classes.startIcon,
          endIcon: classes.endIcon,
          ...props.classes,
        }}
      >
        {props.children}
      </Button>
    );
  }
);

export default ActionButton;
